import { render, staticRenderFns } from "./alipayApp__list.vue?vue&type=template&id=2d947f0a"
import script from "./alipayApp__list.vue?vue&type=script&lang=js"
export * from "./alipayApp__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports